const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;
const STORAGE = "ca_utm";

export type UTM = Partial<Record<(typeof KEYS)[number] | "referrer" | "landing_path", string>>;

export function captureUTM(): UTM {
  if (typeof window === "undefined") return {};
  try {
    const existing = sessionStorage.getItem(STORAGE);
    if (existing) return JSON.parse(existing);
    const params = new URLSearchParams(window.location.search);
    const data: UTM = {};
    for (const k of KEYS) {
      const v = params.get(k);
      if (v) data[k] = v;
    }
    data.referrer = document.referrer || "";
    data.landing_path = window.location.pathname + window.location.search;
    sessionStorage.setItem(STORAGE, JSON.stringify(data));
    return data;
  } catch {
    return {};
  }
}

export function getUTM(): UTM {
  if (typeof window === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

export function getSessionId(): string {
  if (typeof window === "undefined") return "ssr";
  try {
    let id = sessionStorage.getItem("ca_sid");
    if (!id) {
      id = (crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2)) + "-" + Date.now();
      sessionStorage.setItem("ca_sid", id);
    }
    return id;
  } catch { return "anon"; }
}
